import { useRouter } from "next/navigation";

import withHook from "../utilities/withHook";

import { useCaptureSomethingWentWrong } from "./SomethingWentWrong";

const SomethingWasNotFound = () => {
	const router = useRouter();
	router.push("/not-found");
	return null;
};

export default withHook(useCaptureSomethingWentWrong)(SomethingWasNotFound);
